import React from 'react';
import {
  shape,
  string,
  bool,
  number,
  arrayOf
} from 'prop-types';
import { formatDate, showTodayOrTomorrow } from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { IDS } from '../../../../automationTestIds';

const DefaultBoSS = ({ fulfillment, backordered, backorderedShipDate }) => {
  const startDate = formatDate(fulfillment?.deliveryDates?.startDate);
  const endDate = formatDate(fulfillment?.deliveryDates?.endDate);
  const deliveryEndDate = fulfillment?.deliveryDates?.endDate;
  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Store"
          icon="pick-up-true"
          automationId={IDS.LABEL.stsLabel}
        />
        <div className="fulfillment__sub-title" data-automation-id={IDS.ETA.stsETA}>
          <>
            <div>{backordered && 'Backordered'}</div>
            <div>{!backordered && startDate && 'Pickup'}</div>
            {startDate && startDate === endDate && (
              <div className="u__bold">
                {showTodayOrTomorrow(deliveryEndDate, false, fulfillment?.deliveryTimeline, endDate)}
              </div>
            )}
            {startDate && startDate !== endDate && (
              <div>
                <span className="u__bold">
                  {startDate}
                </span>
                {endDate && (
                  <span className="u__bold"> - {endDate}</span>
                )}
              </div>
            )}
          </>
        </div>
      </div>
      <TileFooter className="u__bold">
        <span className="u__text--success">FREE</span>
      </TileFooter>
    </>
  );
};

DefaultBoSS.propTypes = {
  backordered: bool,
  backorderedShipDate: string,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }).isRequired
};

DefaultBoSS.defaultProps = {
  backordered: false,
  backorderedShipDate: null
};

export { DefaultBoSS };
